import { Tooltip } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { API_END, API_ERROR, API_START } from '../redux/api';
import SaveIcon from '@material-ui/icons/Save';

const iconColor = {
  "Saving...": "gray",
  "Saved": "black",
  "Not saved": "red"
};

const ApiMessage = ({ action }) => {
  const [display, setDisplay] = useState('');
  const [hover, setHover] = useState('');

  var api = useSelector((state) => state.api);

  useEffect(() => {
    let timeout;
    if (api?.action?.payload != action) return;
    switch (api.action.type) {
      case API_START:
        setDisplay('Saving...');
        setHover('In progress');
        break;
      case API_END:
        setDisplay('Saved');
        setHover('Saved successfully');
        timeout = setTimeout(() => setDisplay(''), 2000);
        return () => {
          clearTimeout(timeout);
        };
      case API_ERROR:
        setDisplay('Not saved');
        setHover('Not saved');
        timeout = setTimeout(() => setDisplay(''), 4000);
        return () => {
          clearTimeout(timeout);
        };
      default:
    }
  }, [api]);

  return (
    <>
      {iconColor[display] && (
        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          <Tooltip title={hover}>
            <SaveIcon
              style={{ color: iconColor[display], margin: '0 auto' }}
              fontSize="small"
            />
          </Tooltip>
        </div>
      )}
      {/* <Typography style={{ fontSize: 12 }}>{display}</Typography> */}
    </>
  );
};

export default ApiMessage;
